import { ref, watch, onMounted, type Ref } from 'vue';
import { useMainStore } from '../store';
import { trackQuizGateStart, trackQuizGateInput } from '../analytics/events';
import type { QuizData } from '../types';
import type { LeadFormModel } from './useLeadSubmit';

/**
 * Gate view analytics — quiz_gate_start on mount, quiz_gate_input once when
 * both name and email are non-empty. Extracted from Gate.vue (DEV-1135) so the
 * legacy Gate and the flow engine's gate block fire identical events.
 */
export function useGateAnalytics(quizData: QuizData, form: Ref<LeadFormModel>) {
  const store = useMainStore();
  const gateInputFired = ref(false);

  watch(
    [() => form.value.name, () => form.value.email],
    ([name, email]) => {
      if (gateInputFired.value) return;
      if (name?.trim() && email?.trim()) {
        trackQuizGateInput({ quiz_id: quizData.quiz_id });
        gateInputFired.value = true;
      }
    }
  );

  onMounted(() => {
    trackQuizGateStart({
      quiz_id: quizData.quiz_id,
      questions_answered: store.questionAnswers.length,
    });
  });
}
